import PortalIdParser from 'PortalIdParser';
import { getObjectTypeIconComponent } from 'customer-data-objects-ui-components/objects/getObjectTypeIconComponent';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrmObjectBlock = ({
  block,
  callbacks
}) => {
  const url = `${getFullUrlWithCurrentSubDomain()}/go-to/${PortalIdParser.get()}/${block.objectTypeId}/${block.objectId}`;
  const IconComponent = getObjectTypeIconComponent(block.objectTypeId);
  const handleClick = useCallback(() => {
    var _callbacks$COMPOSABLE, _callbacks$COMPOSABLE2;
    callbacks === null || callbacks === void 0 || (_callbacks$COMPOSABLE = callbacks.COMPOSABLE_CARD) === null || _callbacks$COMPOSABLE === void 0 || (_callbacks$COMPOSABLE2 = _callbacks$COMPOSABLE.onCrmObjectClick) === null || _callbacks$COMPOSABLE2 === void 0 || _callbacks$COMPOSABLE2.call(_callbacks$COMPOSABLE, block.objectTypeId);
  }, [callbacks, block.objectTypeId]);
  return /*#__PURE__*/_jsxs(Link, {
    "data-skip-nav-link-tracking": true,
    href: url,
    target: "_top",
    rel: "noopener noreferrer",
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: IconComponent,
      compact: true,
      marginInlineEnd: "200"
    }), /*#__PURE__*/_jsx(TruncateString, {
      children: block.name
    })]
  });
};
export default CrmObjectBlock;